/**
 * Campaign Onboarding - DOM context helpers for step callbacks
 */
(function (global) {
  "use strict";

  function createContext() {
    return {
      setField: function (id, value) {
        var el = document.getElementById(id);
        if (el) el.textContent = value;
      },
      enableButton: function (id) {
        var btn = document.getElementById(id);
        if (btn) btn.disabled = false;
      },
      showElement: function (id) {
        var el = document.getElementById(id);
        if (el) el.classList.remove("hidden");
      },
      hideElement: function (id) {
        var el = document.getElementById(id);
        if (el) el.classList.add("hidden");
      },
    };
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.createContext = createContext;
})(typeof window !== "undefined" ? window : this);
